/** Request a new HTML document; its hashed assets identify the current build.
 * This does not erase saved work, browser-wide caches, or the current sign-in.
 * Sign-out clears its session separately before calling this function.
 */
export function reloadLatestApp(destination = window.location.href): void {
  const url = new URL(destination, window.location.origin);
  url.searchParams.set('_appRefresh', crypto.randomUUID());
  window.location.replace(url.pathname + url.search + url.hash);
}
